exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-and-conditions {\n  padding: 10px 40px;\n  background-color: white;\n}\n\n.logo {\n  margin-bottom: 20px;\n}\n\n.container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.control-buttons {\n  padding: 16px 0;\n}\n\n", ""]);

// exports
